export default __webpack_public_path__ + "static/media/icaew_background_s2.d61419d3.jpg";